import { Button, Empty } from "antd";
import React from "react";
import DisabledWithReason from "../DisabledWithReason/DisabledWithReason";
import SaleInfoSection from "../SaleInfoSection/SaleInfoSection";
import SplitRule from "../SplitRule/SplitRule";

const SplitRulesSection = ({ sale, onCreateSplit, onSplitDeleted }) => {
  const supported = Boolean(sale?.capabilities?.split);
  const rules = sale?.split_rules;

  const extra = (
    <DisabledWithReason
      disabled={!supported}
      reason="Criação de split ainda não disponível para esta adquirente."
    >
      <Button type="primary" onClick={onCreateSplit} disabled={!supported}>
        Criar Split
      </Button>
    </DisabledWithReason>
  );

  const renderBody = () => {
    if (!supported) {
      return <Empty description="Regras de split ainda não disponíveis para esta adquirente." />;
    }
    if (!rules || rules.length === 0) {
      return <Empty description="Nenhuma regra de split para esta venda." />;
    }
    return (
      <SplitRule
        originalAmount={sale?.original_amount}
        fees={sale?.acquirer_fee}
        data={rules}
        transactionId={sale?.id}
        onSplitDeleted={onSplitDeleted}
      />
    );
  };

  return (
    <SaleInfoSection title="Regras de split" extra={extra} minHeight={150}>
      <div className="container-split">{renderBody()}</div>
    </SaleInfoSection>
  );
};

export default SplitRulesSection;
